import { lazy } from 'react';

const HeroStoryMoment = lazy(() => import('../HeroStoryMoment'));

const HeroStoryMomentLazy = () => {
  return <HeroStoryMoment />;
};

export default HeroStoryMomentLazy; 